import React from "react";
import cx from "classnames";
import style from "./Clients.module.scss";
import Section from "../../atoms/Section/Section";
import { Container, Row } from "../../atoms/Containers/Conainers";
import GreenTitle from "../../atoms/GreenTitle/GreenTitle";
import Text from "../../atoms/Text/Text";
import Space from "../../elements/Space/Space";




const Clients = () => (
  <Section>
    <Container>
      <Row>
        <div className='col-12 col-md-6 mb-3 mb-md-0'>
          <h2 className='m-0'>I nostri Clienti</h2>
        </div>
        <div className='col-12 col-md-6 mt-3'>
          <GreenTitle caps>ABBIAMO LAVORATO CON</GreenTitle>
        </div>
      </Row>
      <Space mobile={7} table={7} desktop={7} />
      <Row>
        <div className={cx("col-6 col-md", style.logoWrapper)}>
          <img src="/clients/puntoquinto.png" className={cx(style.logo)} />
        </div>
        <div className={cx("col-6 col-md", style.logoWrapper)}>
          <img src="/clients/urcar.png" className={cx(style.logo)} />
        </div>
        <div className={cx("col-6 col-md", style.logoWrapper)}>
          <img src="/clients/sistema.png" className={cx(style.logo)} />
        </div>
        <div className={cx("col-6 col-md", style.logoWrapper)}>
          <img src="/clients/axis.png" className={cx(style.logo)} />
        </div>
        <div className={cx("col-6 col-md", style.logoWrapper)}>
          <img src="/clients/spc.png" className={cx(style.logo)} />
        </div>
      </Row>
    </Container>
  </Section>
);

export default Clients;
